import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {size} from 'lodash';

import {showSwitchUserWindow} from "../../../actions/auth";
import {AccessRights} from "../../../schemas/accessRightsModel";

const outerStyle = {
  position: 'relative',
  top: '10px',
  height: '100%',
  // display: 'flex',
  // justifyContent: 'center',
  // flexDirection: 'column',
  // marginTop: "-2px"
}

const innerStyle = {
  fontSize: '12px'
}

const CurrentUser = (props) => {

  const {asCustomer, auth, showSwitchUserWindow, AR} = props;

  const canSwitchUsers = AR.canSwitchUsers();

  const roleFriendlyName = () => {

    if (!size(auth.roles))
      return "";
    const role = auth.roles[0].toLowerCase();
    switch (role) {
      case 'fabricator.admin':
        return 'Licensed Admin';
      case 'fabricator.master':
        return 'Master Fabricator';
      case 'fabricator.user':
        return 'Employee';
      case 'client.user':
        return 'Customer';
      case 'site.admin':
        return 'Site Admin';
      default:
        return role;
    }
  }

  const handleButtonClick = (event) => {
    if (!canSwitchUsers) {
      return null
    }
    const excludedClassNames = ["header-user-name", "header-user-title"];
    if (excludedClassNames.some(className => event.target.classList.contains(className)
      || event.target.closest("."+className))) {
      return false
    }
    showSwitchUserWindow(true)
  };

  // if (asCustomer.activeEntity) {
  //   console.log(asCustomer.activeEntity)
  // }

  return (
    <div className={"transition flex flex--center header-user"
      + (!canSwitchUsers ? " header-user--customer" : "")}
         onClick={handleButtonClick}>
      <div className={"central-hub-customers-icon header-user-icon"}>
        <div className="central-hub-icon-desc">Switch User</div>
      </div>
      <div className="header-user-name">
        <span className="header-user-name__title">
          {auth.customerName ? <div>{`${auth.customerName} (${(roleFriendlyName())})`}</div> : null}
          {asCustomer.activeEntity ? "as " + asCustomer.activeEntity.name : null}
        </span>
        {!asCustomer.activeEntity && auth.userEmail
          ? <span className="header-user-name__title">{auth.userEmail}</span>
          : null}
        {asCustomer.activeEntity && asCustomer.activeEntity.companyName && (asCustomer.activeEntity.companyName !== asCustomer.activeEntity.name)
          ? <span className="header-user-name__title">{asCustomer.activeEntity.companyName}</span>
          : null}
      </div>
    </div>
  )
}

CurrentUser.propTypes = {
  asCustomer: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
}

function mapStateToProps(store) {
  const {asCustomer, auth} = store;
  const AR = AccessRights.get(store);

  return {
    asCustomer,
    auth,
    AR,
  }
}

const mapDispatchToProps = {
  showSwitchUserWindow
};

export default connect(mapStateToProps, mapDispatchToProps)(
  CurrentUser
);

